import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  ToggleButton,
  ToggleButtonGroup,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Chip,
  Stack,
} from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { showToast, WEBSERVICE, showNextStepPrompt } from '../CoreDataService';
import axios from 'axios';
import adCenterApi from '../adCenterApi';
import { useBroker } from '../contexts/BrokerContext';
import { useNavigate } from 'react-router-dom';
import { useInfoModal } from '../contexts/InfoModalContext';
import { CircularProgress } from '@mui/material';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import BannerImageCropper from './Bannerimagecropper';

const CreateCampaignPage = () => {
  const [campaignName, setCampaignName] = useState('');
  const [campaignType, setCampaignType] = useState('sponsored'); // 'sponsored', 'post', 'reel', 'boost-post', 'boost-reel', 'boost-tagged-post', 'banner', 'hashtag', 'app-store', 'token-marketplace', 'merchant-marketplace'
  const [description, setDescription] = useState('');
  const [mediaType, setMediaType] = useState('single');
  const [mediaFiles, setMediaFiles] = useState([]);
  const [cta, setCta] = useState('');
  const [headline, setHeadline] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [callToActionUrl, setCallToActionUrl] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // New states for reel-specific fields
  const [reelTitle, setReelTitle] = useState('');
  const [coverImage, setCoverImage] = useState(null);
  const [hashtags, setHashtags] = useState('');

  // New states for post selection
  const [openPostModal, setOpenPostModal] = useState(false);
  const [userPosts, setUserPosts] = useState([]);
  const [userReels, setUserReels] = useState([]);
  const [loadingPosts, setLoadingPosts] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  // New states for hashtag promotion
  const [userHashtags, setUserHashtags] = useState([]);
  const [selectedHashtag, setSelectedHashtag] = useState('');
  const [loadingHashtags, setLoadingHashtags] = useState(false);

  // New states for app store, token marketplace, and merchant marketplace
  const [selectedApp, setSelectedApp] = useState('');
  const [userApps, setUserApps] = useState([]);
  const [loadingApps, setLoadingApps] = useState(false);

  const [selectedToken, setSelectedToken] = useState('');
  const [userTokens, setUserTokens] = useState([]);
  const [loadingTokens, setLoadingTokens] = useState(false);

  const [selectedMerchant, setSelectedMerchant] = useState('');
  const [userMerchants, setUserMerchants] = useState([]);
  const [loadingMerchants, setLoadingMerchants] = useState(false);

  const [selectedPageId, setSelectedPageId] = useState(null);
  const [selectedVideoDuration, setSelectedVideoDuration] = useState(null);
  const [selectedPostType, setSelectedPostType] = useState(null);

  const fileInputRef = useRef();
  const coverImageInputRef = useRef();
  const { brokerDetails } = useBroker();
  const navigate = useNavigate();
  const { showInfoModal } = useInfoModal();

  const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
  const IMAGE_EXTENSIONS = ['jpeg', 'jpg', 'png', 'gif'];
  const VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/x-ms-wmv', 'video/x-msvideo'];
  const VIDEO_EXTENSIONS = ['mp4', 'mov', 'wmv', 'avi'];
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
  const MAX_VIDEO_SIZE = 50 * 1024 * 1024; // 50MB in bytes for reels


  const [cropperOpen, setCropperOpen] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);

  const settings = {
    dots: true,
    infinite: mediaFiles.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  useEffect(() => {
    // fetchBrokerDetails();
  }, []);

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", left: "10px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", right: "10px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  }

  // Fetch user posts from API
  const fetchUserPosts = async () => {
    setLoadingPosts(true);
    try {
      const userId = localStorage.getItem('bitoConnectUserId') || '5';
      const response = await axios.get(
        `https://institutional-bo.paybito.com:8443/BitohubService/post/getAllPostsByUser`,
        {
          params: {
            userId: userId,
            page: 1,
            size: 50
          },
          headers: {
            //authorization: `bearer ${localStorage.getItem('access_token_us')}`,
          },
        }
      );

      if (response.data.success) {
        setUserPosts(response.data.data.content);
      } else {
        showToast('error', 'Failed to load posts');
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
      showToast('error', 'Error loading posts');
    } finally {
      setLoadingPosts(false);
    }
  };

  // Fetch user reels from API
  const fetchUserReels = async () => {
    setLoadingPosts(true);
    try {
      const userId = localStorage.getItem('bitoConnectUserId') || '5';
      const response = await axios.get(
        `https://institutional-bo.paybito.com:8443/BitohubService/reels/getAllReelsByUser`,
        {
          params: {
            userId: userId,
            page: 0,
            size: 10
          },
          headers: {
            //authorization: `bearer ${localStorage.getItem('access_token_us')}`,
          },
        }
      );

      if (response.data.success) {
        setUserReels(response.data.data.content);
      } else {
        showToast('error', 'Failed to load reels');
      }
    } catch (error) {
      console.error('Error fetching reels:', error);
      showToast('error', 'Error loading reels');
    } finally {
      setLoadingPosts(false);
    }
  };

  const fetchUserHashtags = async () => {
    setLoadingHashtags(true);
    try {
      const adminUser = localStorage.getItem('uuid');
      if (!adminUser) {
        showToast('error', 'Error loading hashtags');
        return;
      }
      const response = await axios.get(
        `https://institutional-bo.paybito.com:8443/BitohubService/feeds/getHashtagsByUser`,
        {
          params: {
            adminUser: adminUser,
            offset: 1,
            limit: 100
          },
          headers: {
            //authorization: `bearer ${localStorage.getItem('access_token_us')}`,
          },
        }
      );

      const hasHashtags = response.data.success === true && response.data.data && response.data.data.length > 0;

      if (hasHashtags) {
        setUserHashtags(response.data.data);
      } else {
        showInfoModal({
          title: 'Promote a Hashtag',
          message: "You haven't created any hashtags yet.\n\nCreate a hashtag to feature it on BitoCircle.",
          confirmLabel: 'Create a post with a Hashtag',
          showCancel: false,
          onConfirm: () => {
            const appval = localStorage.getItem('appData');
            const url = `https://bitocircle.com?app=${encodeURIComponent(appval)}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          }
        });
      }
    } catch (error) {
      console.error('Error fetching hashtags:', error);
      showToast('error', 'Error loading hashtags');
    } finally {
      setLoadingHashtags(false);
    }
  };

  // Fetch user tokens from API
  const fetchUserTokens = async () => {
    setLoadingTokens(true);
    try {
      const brokerId = localStorage.getItem("brokerId");

      const response = await adCenterApi.get('/getTokenDetailsByBroker', {
        params: { callFrom: "AD_CENTER" },
      });

      const data = response.data;

      if (data.statusCode === 200 && data.data && data.data.length > 0) {
        // 🔥 MAP THE API RESPONSE TO MATCH YOUR CODE
        const mappedTokens = data.data.map(token => ({
          tokenId: token.currencyId,           // Map currencyId → tokenId
          tokenName: token.currencyName,       // Map currencyName → tokenName
          tokenSymbol: token.currencyCode,     // Map currencyCode → tokenSymbol
          logoLink: token.logoLink,
          websiteLink: token.websiteLink,
          network: token.network
        }));

        setUserTokens(mappedTokens);
        showToast('success', `${mappedTokens.length} token(s) loaded successfully`);
      } else {
        showInfoModal({
          title: 'Token Marketplace Listing',
          message: 'You do not have any token assets created or imported yet.\n\nCreate or import your asset and then feature it on the Token Marketplace.',
          confirmLabel: 'Create or Import Token',
          cancelLabel: 'Go to Token Marketplace',
          onConfirm: () => {
            const appval = localStorage.getItem('appData');
            const url = `https://bitocircle.com/token-marketplace/list-a-token/?app=${encodeURIComponent(appval)}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          },
          onCancel: () => {
            const appval = localStorage.getItem('appData');
            const url = `https://bitocircle.com/token-marketplace/?app=${encodeURIComponent(appval)}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          }
        });
      }
    } catch (error) {
      console.error("Error fetching tokens:", error);
      showToast("error", "Error loading tokens");
    } finally {
      setLoadingTokens(false);
    }
  };


  // Fetch user apps from API
  const fetchUserApps = async () => {
    setLoadingApps(true);
    try {
      const response = await adCenterApi.get('/getAppDetailsByBroker', {
        params: {
          adminUser: localStorage.getItem('uuid')
        },
      });

      // Check for both statusCode 0 and 200 for compatibility, and verify length > 0
      const hasApps = (response.data.statusCode === 0 || response.data.statusCode === 200) &&
        (response.data.apps || response.data.data) &&
        ((response.data.apps || response.data.data).length > 0);

      if (hasApps) {
        const apps = response.data.apps || response.data.data;
        
        // MAP THE API RESPONSE TO MATCH YOUR CODE
        const mappedApps = apps.map(app => ({
          appId: app.APP_ID,      // Map APP_ID → appId
          appName: app.NAME       // Map NAME → appName
        }));

        setUserApps(mappedApps);
        showToast('success', `${mappedApps.length} app(s) loaded successfully`);
      } else {
        showInfoModal({
          title: 'App Store Verification',
          message: 'You do not have any apps published on the App Store.\n\nPublish your app to feature it here.',
          confirmLabel: 'Publish App',
          cancelLabel: 'Cancel',
          onConfirm: () => {
            const appval = localStorage.getItem('appData');
            const url = `https://developers.paybito.com/apps/submit?app=${encodeURIComponent(appval)}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          }
        });
      }
    } catch (error) {
      console.error('Error fetching apps:', error);
      showToast('error', 'Error loading apps');
    } finally {
      setLoadingApps(false);
    }
  };

  // Fetch user merchants from API
  const fetchUserMerchants = async () => {
    setLoadingMerchants(true);
    try {
      const response = await adCenterApi.get('/getMerchantDetailsByBroker', {
        params: {
          adminUser: localStorage.getItem('uuid'),
          callFrom: 'AD_CENTER'
        },
      });

      // Check for both statusCode 0 and 200 for compatibility, and verify length > 0
      const hasMerchants = (response.data.statusCode === 0 || response.data.statusCode === 200) &&
        (response.data.merchants || response.data.data) &&
        ((response.data.merchants || response.data.data).length > 0);

      if (hasMerchants) {
        const merchants = response.data.merchants || response.data.data;
        setUserMerchants(merchants);
        showToast('success', `${merchants.length} merchant(s) loaded successfully`);
      } else {
        showInfoModal({
          title: 'Become a Merchant',
          message: 'You do not have a merchant account created yet.\n\nBecome a merchant or PSP to feature your store on Crypto Commerce.',
          confirmLabel: 'Become a Merchant',
          cancelLabel: 'Go to Crypto Commerce',
          onConfirm: () => {
            const appval = localStorage.getItem('appData');
            const url = `https://bitocircle.com/crypto-commerce/become-a-merchant/?app=${encodeURIComponent(appval)}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          },
          onCancel: () => {
            const appval = localStorage.getItem('appData');
            const url = `https://bitocircle.com/crypto-commerce/?app=${encodeURIComponent(appval)}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          }
        });
      }
    } catch (error) {
      console.error('Error fetching merchants:', error);
      showToast('error', 'Error loading merchants');
    } finally {
      setLoadingMerchants(false);
    }
  };

  // Handle campaign type change
  const handleCampaignTypeChange = (e) => {
    const value = e.target.value;
    setCampaignType(value);

    // Always reset when changing campaign type
    setSelectedPost(null);
    setMediaFiles([]);
    setDescription('');
    setHeadline('');
    setSearchQuery('');
    setReelTitle('');
    setCoverImage(null);
    setHashtags('');
    setCta('');
    setWebsiteUrl('');
    setCallToActionUrl('');
    setSelectedHashtag('');
    setSelectedApp('');
    setSelectedToken('');
    setSelectedMerchant('');

    // Reset new states
    setSelectedPageId(null);
    setSelectedVideoDuration(null);
    setSelectedPostType(null);

    if (value === 'post' || value === 'boost-post' || value === 'boost-tagged-post') {
      setOpenPostModal(true);
      fetchUserPosts();
    } else if (value === 'reel' || value === 'boost-reel') {
      setOpenPostModal(true);
      fetchUserReels();
      setMediaType('single'); // Reels are always single video
    } else if (value === 'hashtag') {
      fetchUserHashtags();
    } else if (value === 'banner') {
      setMediaType('single'); // Banner ads are single image
    } else if (value === 'app-store') {
      fetchUserApps();
    } else if (value === 'token-marketplace') {
      fetchUserTokens();
    } else if (value === 'merchant-marketplace') {
      fetchUserMerchants();
    }
  };

  // Check if current campaign type is a boost type
  const isBoostCampaign = () => {
    return campaignType === 'boost-post' || campaignType === 'boost-reel' || campaignType === 'boost-tagged-post';
  };

  // Replace the existing handleSelectPost function
  const handleSelectPost = async (post) => {
    setSelectedPost(post);

    // Store pageId, videoDuration, and postType
    setSelectedPageId(post.pageId || null);
    setSelectedVideoDuration(post.videoDuration || null);
    setSelectedPostType(post.postType || null);

    // Set description from post content
    if (post.content) {
      setDescription(post.content);
    }

    // Handle media files from post
    if (post.mediaUrls) {
      const urls = post.mediaUrls.split(',').map(url => url.trim());

      // Determine media type based on number of media items
      setMediaType(urls.length === 1 ? 'single' : 'carousel');

      // Create media objects directly from URLs
      const loadedMedia = urls.map((url, index) => {
        // Determine file type from URL
        const fileExtension = url.split('.').pop().split('?')[0].toLowerCase();
        const isVideo = VIDEO_EXTENSIONS.includes(fileExtension);

        return {
          file: null, // Will be fetched during submission
          type: isVideo ? 'video/mp4' : 'image/jpeg',
          url: url, // Use original URL for preview
          isFromPost: true // Flag to identify post media
        };
      });

      setMediaFiles(loadedMedia);

      // Close modal
      setOpenPostModal(false);

      if (campaignType === 'boost-post' || campaignType === 'boost-tagged-post') {
        showToast('success', 'Post selected for boosting! No modifications allowed.');
      } else {
        showToast('success', 'Post selected successfully! You can add more media if needed.');
      }
    } else {
      // Close modal even if no media
      setOpenPostModal(false);
      showToast('success', 'Post selected successfully!');
    }
  };

  // Replace the existing handleSelectReel function
  const handleSelectReel = async (reel) => {
    setSelectedPost(reel); // Reuse selectedPost state for reels

    // Store pageId, videoDuration, and postType
    setSelectedPageId(reel.pageId || null);
    setSelectedVideoDuration(reel.videoDuration || reel.duration || null);
    setSelectedPostType('REEL'); // Reels have a fixed post type

    // Set description from reel description/title
    if (reel.description) {
      setDescription(reel.description);
    } else if (reel.title) {
      setDescription(reel.title);
    }

    // Set reel title
    if (reel.title) {
      setReelTitle(reel.title);
    }

    // Set headline from title
    if (reel.title) {
      setHeadline(reel.title);
    }

    // Set hashtags if available
    if (reel.hashtags) {
      setHashtags(reel.hashtags);
    }

    // Handle video from reel
    if (reel.videoUrl) {
      setMediaType('single'); // Reels are always single video

      // Create media object for the reel video
      const reelMedia = {
        file: null,
        type: 'video/mp4',
        url: reel.videoUrl,
        isFromPost: true,
        coverImage: reel.coverImage
      };

      setMediaFiles([reelMedia]);

      // Set cover image if available
      if (reel.coverImage) {
        setCoverImage({
          url: reel.coverImage,
          isFromReel: true
        });
      }

      // Close modal
      setOpenPostModal(false);

      if (campaignType === 'boost-reel') {
        showToast('success', 'Reel selected for boosting! No modifications allowed.');
      } else {
        showToast('success', 'Reel selected successfully!');
      }
    } else {
      setOpenPostModal(false);
      showToast('warning', 'Selected reel has no video');
    }
  };

  // Handle cover image upload
  const handleCoverImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const isImage = IMAGE_TYPES.includes(file.type) || IMAGE_EXTENSIONS.includes(fileExtension);

    if (!isImage) {
      showToast('error', 'Please upload a valid image file (JPG, PNG, GIF)');
      e.target.value = null;
      return;
    }

    if (file.size > MAX_IMAGE_SIZE) {
      showToast('error', 'Cover image must be less than 5MB');
      e.target.value = null;
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      setCoverImage({
        file: file,
        url: event.target.result,
        isFromReel: false
      });
      showToast('success', 'Cover image uploaded successfully');
    };
    reader.readAsDataURL(file);
    e.target.value = null;
  };

  // Handle cropped image from cropper
  const handleCroppedImage = (croppedFile) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      setMediaFiles([{
        file: croppedFile,
        type: croppedFile.type,
        url: event.target.result
      }]);
    };
    reader.readAsDataURL(croppedFile);
  };

  const handleMediaUpload = (e) => {
    const files = Array.from(e.target.files);
    const limit = mediaType === 'single' ? 1 : 6;

    // For banner ads, open cropper instead of directly uploading
    if (campaignType === 'banner' && files.length > 0) {
      const file = files[0];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const isImage = IMAGE_TYPES.includes(file.type) || IMAGE_EXTENSIONS.includes(fileExtension);

      if (!isImage) {
        showToast('error', 'Banner ads only support image files (JPG, PNG, GIF)');
        e.target.value = null;
        return;
      }

      if (file.size > MAX_IMAGE_SIZE) {
        showToast('error', 'Image file must be less than 5MB');
        e.target.value = null;
        return;
      }

      // Read file and open cropper
      const reader = new FileReader();
      reader.onload = (event) => {
        setImageToCrop(event.target.result);
        setCropperOpen(true);
      };
      reader.readAsDataURL(file);
      e.target.value = null;
      return;
    }

    // For reels, only accept video files
    if (campaignType === 'reel' && files.length > 0) {
      const file = files[0];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const isVideo = VIDEO_TYPES.includes(file.type) || VIDEO_EXTENSIONS.includes(fileExtension);

      if (!isVideo) {
        showToast('error', 'Reels must be video files (MP4, MOV, WMV, AVI)');
        e.target.value = null;
        return;
      }

      if (file.size > MAX_VIDEO_SIZE) {
        showToast('error', 'Video file must be less than 50MB');
        e.target.value = null;
        return;
      }
    }

    // Clear existing files if single media type
    if (mediaType === 'single') {
      setMediaFiles([]);
    }

    // Calculate how many new files we can accept
    const availableSlots = limit - mediaFiles.length;
    const filesToProcess = files.slice(0, availableSlots);
    const validFiles = [];
    const errors = [];

    // First pass: validate all files before processing
    filesToProcess.forEach((file) => {
      // Check both MIME type and file extension
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const isImage = IMAGE_TYPES.includes(file.type) || IMAGE_EXTENSIONS.includes(fileExtension);
      const isVideo = VIDEO_TYPES.includes(file.type) || VIDEO_EXTENSIONS.includes(fileExtension);

      // Explicitly reject JFIF files
      if (fileExtension === 'jfif') {
        errors.push(`Unsupported file type: ${file.name} (JFIF format not allowed)`);
        return;
      }

      if (!isImage && !isVideo) {
        errors.push(`Unsupported file type: ${file.name}`);
        return;
      }

      if (isImage && file.size > MAX_IMAGE_SIZE) {
        errors.push(`Image ${file.name} exceeds 5MB limit`);
        return;
      }

      if (isVideo && file.size > (campaignType === 'reel' ? MAX_VIDEO_SIZE : 15 * 1024 * 1024)) {
        errors.push(`Video ${file.name} exceeds ${campaignType === 'reel' ? '50MB' : '15MB'} limit`);
        return;
      }

      validFiles.push(file);
    });

    if (errors.length > 0) {
      showToast('error', errors.join(', '));
    }

    if (validFiles.length === 0) {
      e.target.value = null;
      return;
    }

    const readers = validFiles.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          resolve({
            file,
            type: file.type,
            url: event.target.result
          });
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readers)
      .then(newMedia => {
        setMediaFiles(prev => {
          const combined = [...prev, ...newMedia];
          const uniqueFiles = combined.reduce((acc, current) => {
            const x = acc.find(item => item.file && item.file.name === current.file.name);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
          return uniqueFiles.slice(0, limit);
        });
      })
      .catch(error => {
        console.error('Error processing files:', error);
        showToast('error', 'Error processing files');
      });

    e.target.value = null;
  };

  const removeMedia = (index) => {
    setMediaFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const removeCoverImage = () => {
    setCoverImage(null);
  };

  const submitCampaign = async () => {
    // Basic form validation
    if (!campaignName.trim()) return showToast('error', 'Campaign Name is required.');

    // Validation for hashtag promotion
    if (campaignType === 'hashtag') {
      if (!selectedHashtag) return showToast('error', 'Please select a hashtag to promote.');
      // For hashtag campaigns, we don't need media or description
    } else if (campaignType === 'app-store') {
      // Validation for app store
      if (!selectedApp) return showToast('error', 'Please select an app to feature.');
      if (!cta) return showToast('error', 'Please select a call to action.');
      if (!callToActionUrl.trim()) return showToast('error', 'Call to action URL is required.');
    } else if (campaignType === 'token-marketplace') {
      // Validation for token marketplace
      if (!selectedToken) return showToast('error', 'Please select a token to promote.');
      if (!cta) return showToast('error', 'Please select a call to action.');
      if (!callToActionUrl.trim()) return showToast('error', 'Call to action URL is required.');
    } else if (campaignType === 'merchant-marketplace') {
      // Validation for merchant marketplace
      if (!selectedMerchant) return showToast('error', 'Please select a merchant to feature.');
      if (!cta) return showToast('error', 'Please select a call to action.');
      if (!callToActionUrl.trim()) return showToast('error', 'Call to action URL is required.');
    } else {
      // For other campaign types (sponsored, post, reel, boost campaigns, banner)
      if (campaignType !== 'banner' && !description.trim()) {
        return showToast('error', 'Description is required.');
      }
      // Only require media files for campaigns that actually need them
      if (mediaFiles.length === 0) {
        return showToast('error', 'At least one media file is required.');
      }
    }

    // Reel-specific validation
    if ((campaignType === 'reel' || campaignType === 'boost-reel') && !isBoostCampaign()) {
      if (!reelTitle.trim()) return showToast('error', 'Reel Title is required.');
      if (mediaFiles.length !== 1 || !mediaFiles[0].type.startsWith('video')) {
        return showToast('error', 'Reel must have exactly one video file.');
      }
    }

    if (mediaType === 'single' && mediaFiles.length !== 1 && campaignType !== 'hashtag' &&
      campaignType !== 'app-store' && campaignType !== 'token-marketplace' && campaignType !== 'merchant-marketplace')
      return showToast('error', 'Please upload exactly 1 media file for "Single" type.');

    if (mediaType === 'carousel' && (mediaFiles.length < 2 || mediaFiles.length > 6))
      return showToast('error', 'Please upload 2-6 media files for "Carousel" type.');

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('campaignName', campaignName);
      formData.append('brokerId', localStorage.getItem('brokerId'));
      formData.append('campaignStatus', 'ACTIVE');

      // Determine campaignType and entityId based on selection
      let apiCampaignType = '';
      let entityIdValue = 0;

      if (campaignType === 'app-store') {
        apiCampaignType = 'APP';
        entityIdValue = selectedApp;
      } else if (campaignType === 'token-marketplace') {
        apiCampaignType = 'TOKEN';
        entityIdValue = selectedToken;
      } else if (campaignType === 'merchant-marketplace') {
        apiCampaignType = 'MERCHANT';
        entityIdValue = selectedMerchant;
      } else if (campaignType === 'sponsored') {
        apiCampaignType = 'SPONSORED';
      } else if (campaignType === 'hashtag') {
        apiCampaignType = 'HASHTAG';
      } else if (campaignType === 'post') {
        apiCampaignType = 'POST';
        entityIdValue = selectedPageId || 0;
      } else if (campaignType === 'reel') {
        apiCampaignType = 'REEL';
        entityIdValue = selectedPageId || 0;
      } else if (campaignType === 'boost-post') {
        apiCampaignType = 'BOOSTPOST';
        entityIdValue = selectedPageId || 0;
      } else if (campaignType === 'boost-tagged-post') {
        apiCampaignType = 'BOOSTTAGGEDPOST';
        entityIdValue = selectedPageId || 0;
      } else if (campaignType === 'boost-reel') {
        apiCampaignType = 'BOOSTREEL';
        entityIdValue = selectedPageId || 0;
      } else if (campaignType === 'banner') {
        apiCampaignType = 'BANNER';
      }

      formData.append('campaignType', apiCampaignType);
      formData.append('entityId', entityIdValue);

      // Add videoDuration and postType parameters
      formData.append('duration', selectedVideoDuration || '0');
      formData.append('postType', selectedPostType || '');

      // Add hashtagId for all campaign types
      if (campaignType === 'hashtag') {
        formData.append('hashtagId', selectedHashtag);
      } else {
        formData.append('hashtagId', 0);
      }

      // For hashtag campaigns - add additional fields
      if (campaignType === 'hashtag') {
        if (cta) formData.append('callToAction', cta);
        if (callToActionUrl) formData.append('callToActionUrl', callToActionUrl);

        // Add empty files and fileLinks for hashtag campaigns
        formData.append('files', '');
        formData.append('fileLinks', '');
      }

      // For app store, token, and merchant marketplace campaigns
      if (campaignType === 'app-store' || campaignType === 'token-marketplace' || campaignType === 'merchant-marketplace') {
        formData.append('callToAction', cta);
        formData.append('callToActionUrl', callToActionUrl);
        if (headline) formData.append('mediaHeadline', headline);
        if (description) formData.append('campaignObjective', description);

        // Add empty files and fileLinks for marketplace campaigns without media
        if (mediaFiles.length === 0) {
          formData.append('files', '');
          formData.append('fileLinks', '');
        }
      }

      // For hashtag campaigns and marketplace campaigns without media, submit here
      if (campaignType === 'hashtag' ||
        (mediaFiles.length === 0 && (campaignType === 'app-store' ||
          campaignType === 'token-marketplace' ||
          campaignType === 'merchant-marketplace'))) {

        const response = await adCenterApi.post('/createCampaign', formData);

        if (response.data.statusCode === 0) {
          const successMessage = campaignType === 'hashtag' ? 'Hashtag promotion campaign created successfully!' :
            campaignType === 'app-store' ? 'App store feature campaign created successfully!' :
              campaignType === 'token-marketplace' ? 'Token marketplace feature campaign created successfully!' :
                'Merchant marketplace feature campaign created successfully!';
          showNextStepPrompt('campaign', navigate, successMessage);
          resetForm();
        } else {
          showToast('error', response.data.message);
        }
        setIsSubmitting(false);
        return;
      }

      // For other campaign types, process media files
      const processedFiles = [];
      const fileLinksArray = [];

      await Promise.all(
        mediaFiles.map(async (media) => {
          if (media.file) {
            // Already a file object (uploaded)
            processedFiles.push(media.file);
          } else if (media.url && media.isFromPost) {
            // Media from post - add URL to fileLinks
            fileLinksArray.push(media.url);
          }
        })
      );

      // Always add files field to formData, even if empty
      if (processedFiles.length > 0) {
        processedFiles.forEach((file) => {
          if (file) formData.append('files', file);
        });
      } else {
        // Send empty files field
        formData.append('files', '');
      }

      // Add fileLinks as comma-separated string if there are any, otherwise send empty
      if (fileLinksArray.length > 0) {
        formData.append('fileLinks', fileLinksArray.join(','));
      } else {
        formData.append('fileLinks', '');
      }

      // Only check for media files if the campaign type requires them
      if (processedFiles.length === 0 && fileLinksArray.length === 0 &&
        campaignType !== 'hashtag' &&
        campaignType !== 'app-store' &&
        campaignType !== 'token-marketplace' &&
        campaignType !== 'merchant-marketplace') {
        setIsSubmitting(false);
        return showToast('error', 'No valid media files to upload');
      }

      formData.append('mediaType', mediaType === 'single' ? 'Single' : 'Carousel');

      // Only add description for non-banner campaigns
      if (campaignType !== 'banner') {
        formData.append('campaignObjective', description || 'No description provided');
      }

      // Only add CTA fields for non-boost campaigns
      if (!isBoostCampaign()) {
        formData.append('callToAction', cta);
        formData.append('callToActionUrl', callToActionUrl);
        formData.append('mediaHeadline', headline);
        formData.append('websiteUrl', websiteUrl);
      }

      // Add reel-specific fields
      if (campaignType === 'reel' || campaignType === 'boost-reel') {
        if (reelTitle) formData.append('title', reelTitle);
        if (hashtags) formData.append('hashtags', hashtags);

        // Add cover image if present
        if (coverImage && coverImage.file) {
          formData.append('coverPic', coverImage.file);
        } else if (coverImage && coverImage.url && coverImage.isFromReel) {
          // If cover image is from reel, send the URL
          formData.append('coverImageUrl', coverImage.url);
        }
      } else {
        formData.append('coverPic', '');
        formData.append('coverImageUrl', '');
        formData.append('title', '');
        formData.append('hashtags', '');
      }

      // If selected from post, add post ID
      if (selectedPost && selectedPost.postId) {
        formData.append('postId', selectedPost.postId);
      }

      // If selected from reel, add reel ID
      if (selectedPost && selectedPost.reelId) {
        formData.append('reelId', selectedPost.reelId);
      }

      const response = await adCenterApi.post('/createCampaign', formData);

      if (response.data.statusCode === 0) {
        showNextStepPrompt('campaign', navigate);
        setIsSubmitting(false);
        resetForm();
      } else {
        showToast('error', response.data.message);
        setIsSubmitting(false);
      }
    } catch (err) {
      setIsSubmitting(false);
      console.error('Campaign creation error:', err);
      showToast('error', 'Something went wrong while saving the campaign. Please try again.');
    }
  };

  // Helper function to reset form
  const resetForm = () => {
    setCampaignName('');
    setCampaignType('sponsored');
    setDescription('');
    setMediaFiles([]);
    setCta('');
    setHeadline('');
    setWebsiteUrl('');
    setCallToActionUrl('');
    setSelectedPost(null);
    setReelTitle('');
    setCoverImage(null);
    setHashtags('');
    setSelectedHashtag('');
    setSelectedApp('');
    setSelectedToken('');
    setSelectedMerchant('');

    // Reset new states
    setSelectedPageId(null);
    setSelectedVideoDuration(null);
    setSelectedPostType(null);
  };

  // Render reel card in modal
  const renderReelCard = (reel) => {
    const isSelected = selectedPost?.reelId === reel.reelId;
    const publishedDate = new Date(reel.createdAt).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });

    return (
      <Card
        key={reel.reelId}
        sx={{
          mb: 2,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            boxShadow: 2,
          }
        }}
      >
        <CardContent sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                Published on {publishedDate}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                by {reel.fullName}
              </Typography>
            </Box>
            <Button
              variant="contained"
              size="small"
              onClick={() => handleSelectReel(reel)}
              sx={{
                textTransform: 'none',
                minWidth: 90,
                bgcolor: isSelected ? 'success.main' : 'primary.main',
                '&:hover': {
                  bgcolor: isSelected ? 'success.dark' : 'primary.dark',
                }
              }}
            >
              {isSelected ? '✓ Selected' : (campaignType === 'boost-reel' ? 'Boost' : 'Use reel')}
            </Button>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            {/* Video thumbnail */}
            <Box
              sx={{
                width: 100,
                height: 140,
                borderRadius: 1,
                overflow: 'hidden',
                bgcolor: '#000',
                flexShrink: 0,
                position: 'relative'
              }}
            >
              {reel.coverImage ? (
                <img
                  src={reel.coverImage}
                  alt="reel cover"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <video
                  src={reel.videoUrl}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  muted
                />
              )}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 4,
                  right: 4,
                  bgcolor: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  px: 0.5,
                  py: 0.25,
                  borderRadius: 0.5,
                  fontSize: '0.7rem'
                }}
              >
                {reel.duration ? `${reel.duration}s` : ''}
              </Box>
            </Box>

            {/* Content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="body2" fontWeight="bold" gutterBottom>
                {reel.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mb: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {reel.description}
              </Typography>
              {reel.hashtags && (
                <Typography variant="caption" color="primary" sx={{ display: 'block', mb: 1 }}>
                  {reel.hashtags}
                </Typography>
              )}
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  👍 {reel.likeCount}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {reel.commentCount} comments
                </Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>

        <Divider />

        <Box sx={{ px: 2, py: 1, bgcolor: 'action.hover' }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box component="span" sx={{ fontSize: '1rem' }}>ℹ️</Box>
            {campaignType === 'boost-reel'
              ? 'This reel will be boosted as-is. No modifications allowed.'
              : 'Reactions, comments and shares from the original post will not be included in your ad.'}
          </Typography>
        </Box>
      </Card>
    );
  };

  // Render post card in modal
  const renderPostCard = (post) => {
    const hasMedia = post.mediaUrls && post.mediaUrls.length > 0;
    const mediaUrlArray = hasMedia ? post.mediaUrls.split(',').map(url => url.trim()) : [];
    const isSelected = selectedPost?.postId === post.postId;
    const publishedDate = new Date(post.createdAt).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });

    // Check if user is tagged in this post
    const currentUserId = localStorage.getItem('bitoConnectUserId') || '5';
    const isUserTagged = post.taggedUserId && post.taggedUserId.toString() === currentUserId.toString();

    return (
      <Card
        key={post.postId}
        sx={{
          mb: 2,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            boxShadow: 2,
          }
        }}
      >
        <CardContent sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                Published on {publishedDate}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                by {post.fullName}
              </Typography>
            </Box>
            <Button
              variant="contained"
              size="small"
              onClick={() => handleSelectPost(post)}
              sx={{
                textTransform: 'none',
                minWidth: 90,
                bgcolor: isSelected ? 'success.main' : 'primary.main',
                '&:hover': {
                  bgcolor: isSelected ? 'success.dark' : 'primary.dark',
                }
              }}
            >
              {isSelected ? '✓ Selected' : (campaignType === 'boost-post' || campaignType === 'boost-tagged-post' ? 'Boost' : 'Use post')}
            </Button>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            {/* Media thumbnail */}
            {hasMedia && (
              <Box
                sx={{
                  width: 100,
                  height: 140,
                  borderRadius: 1,
                  overflow: 'hidden',
                  bgcolor: '#f5f5f5',
                  flexShrink: 0,
                  position: 'relative'
                }}
              >
                {post.postType === 'VIDEO' ? (
                  <video
                    src={mediaUrlArray[0]}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    muted
                  />
                ) : (
                  <img
                    src={mediaUrlArray[0]}
                    alt="post media"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                )}
                {mediaUrlArray.length > 1 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 4,
                      right: 4,
                      bgcolor: 'rgba(0,0,0,0.7)',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 0.5,
                      fontSize: '0.7rem'
                    }}
                  >
                    +{mediaUrlArray.length - 1}
                  </Box>
                )}
              </Box>
            )}

            {/* Content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="body2"
                color="text.primary"
                sx={{
                  mb: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: hasMedia ? 3 : 4,
                  WebkitBoxOrient: 'vertical',
                  fontWeight: post.postType === 'TEXT' ? 500 : 400
                }}
              >
                {post.content || 'No content'}
              </Typography>

              {post.hashtags && (
                <Typography variant="caption" color="primary" sx={{ display: 'block', mb: 1 }}>
                  {post.hashtags}
                </Typography>
              )}

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                <Chip
                  label={post.postType || 'TEXT'}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: '0.65rem',
                    fontWeight: 600
                  }}
                />
                {isUserTagged && (
                  <Chip
                    label="Tagged"
                    size="small"
                    color="secondary"
                    sx={{
                      height: 20,
                      fontSize: '0.65rem',
                      fontWeight: 600
                    }}
                  />
                )}
                <Typography variant="caption" color="text.secondary">
                  ❤️ {post.likeCount || 0}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  💬 {post.commentCount || 0}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  🔄 {post.shareCount || 0}
                </Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>

        <Divider />

        <Box sx={{ px: 2, py: 1, bgcolor: 'action.hover' }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box component="span" sx={{ fontSize: '1rem' }}>ℹ️</Box>
            {campaignType === 'boost-post' || campaignType === 'boost-tagged-post'
              ? 'This post will be boosted as-is. No modifications allowed.'
              : 'Reactions, comments and shares from the original post will not be included in your ad.'}
          </Typography>
        </Box>
      </Card>
    );
  };

  // Check if fields should be disabled (for boost campaigns)
  const areFieldsDisabled = isBoostCampaign();

  // Get CTA options based on campaign type
  const getCtaOptions = () => {
    if (campaignType === 'app-store') {
      return [
        { value: 'Install', label: 'Install' },
        { value: 'Learn More', label: 'Learn More' }
      ];
    } else if (campaignType === 'token-marketplace') {
      return [
        { value: 'Buy Asset', label: 'Buy Asset' },
        { value: 'Invest', label: 'Invest' },
        { value: 'Explore', label: 'Explore' }
      ];
    } else if (campaignType === 'merchant-marketplace') {
      return [
        { value: 'Sign Up', label: 'Sign Up' },
        { value: 'Learn More', label: 'Learn More' },
        { value: 'Shop Now', label: 'Shop Now' },
        { value: 'Contact Us', label: 'Contact Us' }
      ];
    }
    return [
      { value: 'Sign Up', label: 'Sign Up' },
      { value: 'Learn More', label: 'Learn More' },
      { value: 'Shop Now', label: 'Shop Now' },
      { value: 'Contact Us', label: 'Contact Us' },
      { value: 'Download', label: 'Download' }
    ];
  };

  return (
    <Container maxWidth="lg"
      sx={{
        mb: 6,
        '& .slick-prev:before, & .slick-next:before': {
          color: 'black',
          fontSize: '24px'
        },
        '& .slick-prev': {
          left: '-25px'
        },
        '& .slick-next': {
          right: '-25px'
        }
      }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt: 1 }}>
          <Box>
            <Typography variant="h4" component="h1" fontWeight="bold" color="primary.main">
              Create New Ad Campaign
            </Typography>
            <Typography variant="body1" color="text.secondary"
              mt={0.5}
              sx={{
                fontStyle: 'italic'
              }}>
              Set your campaign goals, audience, budget, and schedule to launch an effective advertisement.
            </Typography>
          </Box>
          <Button variant="contained" color="primary" sx={{ fontWeight: 'bold', textTransform: 'none', boxShadow: 2 }} onClick={() => navigate('/get-campaign')}>
            View All Campaigns
          </Button>
        </Box>

        {/* Post/Reel Selection Modal */}
        <Dialog
          open={openPostModal}
          onClose={() => setOpenPostModal(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              {(campaignType === 'reel' || campaignType === 'boost-reel') ? 'Browse reels' :
                campaignType === 'boost-tagged-post' ? 'Browse tagged posts' : 'Browse posts'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {(campaignType === 'reel' || campaignType === 'boost-reel')
                ? (campaignType === 'boost-reel'
                  ? 'Select a reel to boost. The reel will be promoted as-is without any modifications.'
                  : 'Use a reel from your BitoCircle Page. You can change the image, content or leave it as is.')
                : (campaignType === 'boost-post' || campaignType === 'boost-tagged-post'
                  ? (campaignType === 'boost-tagged-post'
                    ? 'Select a post where you are tagged to boost. The post will be promoted as-is without any modifications.'
                    : 'Select a post to boost. The post will be promoted as-is without any modifications.')
                  : 'Use a post from your BitoCircle Page. You can change the image, content or leave it as is.')}
            </Typography>

            {/* Search Bar - Now for both posts and reels */}
            <TextField
              fullWidth
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ mt: 2 }}
              size="small"
              InputProps={{
                startAdornment: (
                  <Box sx={{ color: 'text.disabled', mr: 1 }}>🔍</Box>
                ),
              }}
            />
          </DialogTitle>
          <DialogContent dividers sx={{ minHeight: 400 }}>
            {loadingPosts ? (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
                <CircularProgress />
              </Box>
            ) : (campaignType === 'reel' || campaignType === 'boost-reel') ? (
              // Render Reels
              userReels.length === 0 ? (
                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={300}>
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    No reels found
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Create some reels first to use them in your campaigns
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const appval = localStorage.getItem('appData');
                      const url = `https://bitocircle.com?app=${encodeURIComponent(appval)}`;
                      window.open(url, '_blank', 'noopener,noreferrer');
                    }}
                    sx={{
                      mt: 3,
                      textTransform: 'none',
                      px: 3,
                      py: 1,
                      borderRadius: 2,
                      fontWeight: 600,
                    }}
                  >
                    Go to BitoCircle
                  </Button>
                </Box>
              ) : (
                <Box>
                  {userReels
                    .filter(reel => {
                      if (!searchQuery) return true;
                      const query = searchQuery.toLowerCase();
                      return (
                        reel.title?.toLowerCase().includes(query) ||
                        reel.description?.toLowerCase().includes(query) ||
                        reel.hashtags?.toLowerCase().includes(query)
                      );
                    })
                    .map(reel => renderReelCard(reel))}
                  {userReels.filter(reel => {
                    if (!searchQuery) return true;
                    const query = searchQuery.toLowerCase();
                    return (
                      reel.title?.toLowerCase().includes(query) ||
                      reel.description?.toLowerCase().includes(query) ||
                      reel.hashtags?.toLowerCase().includes(query)
                    );
                  }).length === 0 && searchQuery && (
                      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={200}>
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                          No results found
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Try a different search term
                        </Typography>
                      </Box>
                    )}
                </Box>
              )
            ) : (
              // Render Posts
              userPosts.length === 0 ? (
                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={300}>
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    {campaignType === 'boost-tagged-post' ? 'No tagged posts found' : 'No posts found'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {campaignType === 'boost-tagged-post'
                      ? 'You are not tagged in any posts yet'
                      : 'Create some posts first to use them in your campaigns'}
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const appval = localStorage.getItem('appData');
                      const url = `https://bitocircle.com?app=${encodeURIComponent(appval)}`;
                      window.open(url, '_blank', 'noopener,noreferrer');
                    }}
                    sx={{
                      mt: 3,
                      textTransform: 'none',
                      px: 3,
                      py: 1,
                      borderRadius: 2,
                      fontWeight: 600,
                    }}
                  >
                    Go to BitoCircle
                  </Button>
                </Box>
              ) : (
                <Box>
                  {userPosts
                    .filter(post => {
                      // For boost-tagged-post, only show posts where the user is tagged
                      if (campaignType === 'boost-tagged-post') {
                        const currentUserId = localStorage.getItem('bitoConnectUserId') || '5';
                        const taggedUserId = post.taggedUserId || 0;
                        // Check if current user is tagged in this post
                        const isUserTagged = taggedUserId.toString() === currentUserId.toString();
                        if (!isUserTagged) return false;
                      }

                      // Apply search filter
                      if (!searchQuery) return true;
                      const query = searchQuery.toLowerCase();
                      return (
                        post.content?.toLowerCase().includes(query) ||
                        post.hashtags?.toLowerCase().includes(query) ||
                        post.fullName?.toLowerCase().includes(query)
                      );
                    })
                    .map(post => renderPostCard(post))}

                  {userPosts.filter(post => {
                    // Same filtering logic as above
                    if (campaignType === 'boost-tagged-post') {
                      const currentUserId = localStorage.getItem('bitoConnectUserId') || '5';
                      const taggedUserId = post.taggedUserId || 0;
                      const isUserTagged = taggedUserId.toString() === currentUserId.toString();
                      if (!isUserTagged) return false;
                    }
                    if (!searchQuery) return true;
                    const query = searchQuery.toLowerCase();
                    return (
                      post.content?.toLowerCase().includes(query) ||
                      post.hashtags?.toLowerCase().includes(query) ||
                      post.fullName?.toLowerCase().includes(query)
                    );
                  }).length === 0 && searchQuery && (
                      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={200}>
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                          No results found
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Try a different search term
                        </Typography>
                      </Box>
                    )}

                  {/* Show message if no tagged posts found */}
                  {campaignType === 'boost-tagged-post' &&
                    userPosts.filter(post => {
                      const currentUserId = localStorage.getItem('bitoConnectUserId') || '5';
                      const taggedUserId = post.taggedUserId || 0;
                      return taggedUserId.toString() === currentUserId.toString();
                    }).length === 0 && !searchQuery && (
                      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={200}>
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                          No tagged posts found
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          You are not tagged in any posts yet
                        </Typography>
                      </Box>
                    )}
                </Box>
              )
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenPostModal(false)}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* Main layout container using Box with flex properties */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 4,
          }}
        >
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 7 }}>
              {/* Left Side - Form */}
              <Box>
                <Paper elevation={4} sx={{ p: { xs: 2, md: 4 }, borderRadius: 2 }}>
                  <Typography variant="h6" gutterBottom color="text.primary" fontWeight="medium">
                    Campaign Details
                  </Typography>
                  <Divider sx={{ mb: 3 }} />

                  <TextField
                    fullWidth
                    label="Campaign Name"
                    value={campaignName}
                    onChange={(e) => {
                      if (e.target.value.length <= 55) setCampaignName(e.target.value);
                    }}
                    margin="normal"
                    variant="outlined"
                    helperText={`A descriptive name for your campaign (e.g., 'Summer Sale 2025'). ${campaignName.length}/55 characters`}
                    inputProps={{ maxLength: 55 }}
                    error={campaignName.length > 55}
                  />

                  {/* Campaign Type Dropdown */}
                  <FormControl fullWidth margin="normal" variant="outlined">
                    <InputLabel>Campaign Type</InputLabel>
                    <Select
                      value={campaignType}
                      label="Campaign Type"
                      onChange={handleCampaignTypeChange}
                    >
                      <MenuItem value="sponsored">Create a Sponsored Post</MenuItem>
                      <MenuItem value="post">Use a Post</MenuItem>
                      <MenuItem value="reel">Use a Reel</MenuItem>
                      <MenuItem value="boost-post">Boost a Post</MenuItem>
                      <MenuItem value="boost-tagged-post">Boost a Tagged Post</MenuItem>
                      <MenuItem value="boost-reel">Boost a Reel</MenuItem>
                      <MenuItem value="banner">Create a Banner Ad</MenuItem>
                      <MenuItem value="hashtag">Promote a Hashtag</MenuItem>
                      <MenuItem value="app-store">Feature your app on PayBito App Store</MenuItem>
                      <MenuItem value="token-marketplace">Feature your token on Token Marketplace</MenuItem>
                      <MenuItem value="merchant-marketplace">Feature your store on Crypto Commerce</MenuItem>
                    </Select>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                      {campaignType === 'sponsored' && 'Create a new sponsored ad from scratch'}
                      {campaignType === 'post' && 'Select from your existing posts and customize'}
                      {campaignType === 'reel' && 'Select from your existing reels and customize'}
                      {campaignType === 'boost-post' && 'Boost an existing post as-is (no modifications)'}
                      {campaignType === 'boost-tagged-post' && 'Boost a post where you are tagged as-is (no modifications)'}
                      {campaignType === 'boost-reel' && 'Boost an existing reel as-is (no modifications)'}
                      {campaignType === 'banner' && 'Create a banner advertisement with images only'}
                      {campaignType === 'hashtag' && 'Promote a hashtag you created'}
                      {campaignType === 'app-store' && 'Feature an app from your PayBito App store'}
                      {campaignType === 'token-marketplace' && 'Promote a token on the Token marketplace'}
                      {campaignType === 'merchant-marketplace' && 'Feature a merchant store on the marketplace'}
                    </Typography>
                  </FormControl>

                  {/* App Store Campaign Fields */}
                  {campaignType === 'app-store' && (
                    <>
                      <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel>Select the app that you would like to feature</InputLabel>
                        <Select
                          value={selectedApp}
                          label="Select the app that you would like to feature"
                          onChange={(e) => setSelectedApp(e.target.value)}
                          disabled={loadingApps}
                        >
                          {loadingApps ? (
                            <MenuItem value="">
                              <em>Loading apps...</em>
                            </MenuItem>
                          ) : userApps.length === 0 ? (
                            <MenuItem value="">
                              <em>No apps found</em>
                            </MenuItem>
                          ) : (
                            userApps.map((app) => (
                              <MenuItem key={app.appId} value={app.appId}>
                                {app.appName}
                              </MenuItem>
                            ))
                          )}
                        </Select>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                          Choose an app to feature from your available apps
                        </Typography>
                      </FormControl>

                      <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel>Call to Action</InputLabel>
                        <Select
                          value={cta}
                          label="Call to Action"
                          onChange={(e) => setCta(e.target.value)}
                        >
                          {getCtaOptions().map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                          Select the action you want users to take
                        </Typography>
                      </FormControl>

                      <TextField
                        fullWidth
                        label="Call to action URL"
                        type="url"
                        value={callToActionUrl}
                        onChange={(e) => setCallToActionUrl(e.target.value)}
                        margin="normal"
                        variant="outlined"
                        helperText="The full URL where users will be directed (e.g., https://example.com/app)"
                        placeholder="https://www.paybito.com/app"
                      />
                    </>
                  )}

                  {/* Token Marketplace Campaign Fields */}
                  {campaignType === 'token-marketplace' && (
                    <>
                      <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel>Select the token you would like to promote</InputLabel>
                        <Select
                          value={selectedToken}
                          label="Select the token you would like to promote"
                          onChange={(e) => setSelectedToken(e.target.value)}
                          disabled={loadingTokens}
                        >
                          {loadingTokens ? (
                            <MenuItem value="">
                              <em>Loading tokens...</em>
                            </MenuItem>
                          ) : userTokens.length === 0 ? (
                            <MenuItem value="">
                              <em>No tokens found</em>
                            </MenuItem>
                          ) : (
                            userTokens.map((token) => (
                              <MenuItem key={token.tokenId} value={token.tokenId}>
                                {token.tokenName} ({token.tokenSymbol})
                                {token.network && ` - ${token.network}`}
                              </MenuItem>
                            ))
                          )}
                        </Select>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                          Choose a token to promote from the marketplace
                        </Typography>
                      </FormControl>

                      <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel>Call to Action</InputLabel>
                        <Select
                          value={cta}
                          label="Call to Action"
                          onChange={(e) => setCta(e.target.value)}
                        >
                          {getCtaOptions().map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                          Select the action you want users to take
                        </Typography>
                      </FormControl>

                      <TextField
                        fullWidth
                        label="Call to action URL"
                        type="url"
                        value={callToActionUrl}
                        onChange={(e) => setCallToActionUrl(e.target.value)}
                        margin="normal"
                        variant="outlined"
                        helperText="The full URL where users will be directed (e.g., https://example.com/token)"
                        placeholder="https://www.paybito.com/token"
                      />

                      <TextField
                        fullWidth
                        label="Ad Headline (Optional)"
                        value={headline}
                        onChange={(e) => {
                          if (e.target.value.length <= 100) setHeadline(e.target.value);
                        }}
                        margin="normal"
                        variant="outlined"
                        helperText={`A short, catchy headline for your ad. ${headline.length}/100 characters`}
                        inputProps={{ maxLength: 100 }}
                        error={headline.length > 100}
                        placeholder="Invest in the future"
                      />

                      <TextField
                        fullWidth
                        label="Description (Optional)"
                        multiline
                        rows={3}
                        value={description}
                        onChange={(e) => {
                          if (e.target.value.length <= 255) setDescription(e.target.value);
                        }}
                        margin="normal"
                        variant="outlined"
                        helperText={`Briefly describe the token and its benefits. ${description.length}/255 characters`}
                        inputProps={{ maxLength: 255 }}
                        error={description.length > 255}
                      />
                    </>
                  )}

                  {/* Merchant Marketplace Campaign Fields */}
                  {campaignType === 'merchant-marketplace' && (
                    <>
                      <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel>Select a merchant you would like to feature</InputLabel>
                        <Select
                          value={selectedMerchant}
                          label="Select a merchant you would like to feature"
                          onChange={(e) => setSelectedMerchant(e.target.value)}
                          disabled={loadingMerchants}
                        >
                          {loadingMerchants ? (
                            <MenuItem value="">
                              <em>Loading merchants...</em>
                            </MenuItem>
                          ) : userMerchants.length === 0 ? (
                            <MenuItem value="">
                              <em>No merchants found</em>
                            </MenuItem>
                          ) : (
                            userMerchants.map((merchant) => (
                              <MenuItem key={merchant.merchantId} value={merchant.merchantId}>
                                {merchant.organizationName || merchant.fullName}
                                {merchant.website && ` - ${merchant.website}`}
                              </MenuItem>
                            ))
                          )}
                        </Select>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                          Choose a merchant store to feature
                        </Typography>
                      </FormControl>

                      <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel>Call to Action</InputLabel>
                        <Select
                          value={cta}
                          label="Call to Action"
                          onChange={(e) => setCta(e.target.value)}
                        >
                          {getCtaOptions().map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                          Select the action you want users to take
                        </Typography>
                      </FormControl>

                      <TextField
                        fullWidth
                        label="Call to action URL"
                        type="url"
                        value={callToActionUrl}
                        onChange={(e) => setCallToActionUrl(e.target.value)}
                        margin="normal"
                        variant="outlined"
                        helperText="The full URL where users will be directed (e.g., https://example.com/store)"
                        placeholder="https://www.paybito.com/merchant"
                      />
                    </>
                  )}

                  {/* Hashtag Selection for Promote a Hashtag */}
                  {campaignType === 'hashtag' && (
                    <FormControl fullWidth margin="normal" variant="outlined">
                      <InputLabel>Select Hashtag</InputLabel>
                      <Select
                        value={selectedHashtag}
                        label="Select Hashtag"
                        onChange={(e) => setSelectedHashtag(e.target.value)}
                        disabled={loadingHashtags}
                      >
                        {loadingHashtags ? (
                          <MenuItem value="">
                            <em>Loading hashtags...</em>
                          </MenuItem>
                        ) : userHashtags.length === 0 ? (
                          <MenuItem value="">
                            <em>No hashtags found</em>
                          </MenuItem>
                        ) : (
                          userHashtags.map((hashtag) => (
                            <MenuItem key={hashtag.hashtagId} value={hashtag.hashtagId}>
                              #{hashtag.hashtagName}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                        Choose a hashtag to promote from your created hashtags
                      </Typography>
                    </FormControl>
                  )}

                  {/* Show selected post/reel info */}
                  {selectedPost && (campaignType === 'post' || campaignType === 'reel' || campaignType === 'boost-post' || campaignType === 'boost-tagged-post' || campaignType === 'boost-reel') && (
                    <Paper
                      elevation={0}
                      sx={{
                        my: 2,
                        p: 2.5,
                        bgcolor: 'rgba(46, 125, 50, 0.08)',
                        border: '1px solid',
                        borderColor: 'success.main',
                        borderRadius: 2,
                        position: 'relative',
                        overflow: 'hidden',
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: '4px',
                          bgcolor: 'success.main',
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircleIcon sx={{ color: 'success.main', fontSize: 20 }} />
                          <Typography variant="subtitle2" fontWeight={600} color="success.dark">
                            {(campaignType === 'reel' || campaignType === 'boost-reel') ? 'Reel Selected' :
                              campaignType === 'boost-tagged-post' ? 'Tagged Post Selected' : 'Post Selected'}
                            {isBoostCampaign() && ' for Boosting'}
                          </Typography>
                        </Box>
                        <Chip
                          label={(campaignType === 'reel' || campaignType === 'boost-reel') ? 'REEL' : (selectedPost.postType || 'POST')}
                          size="small"
                          sx={{
                            height: 20,
                            fontSize: '0.7rem',
                            fontWeight: 600,
                            bgcolor: 'success.main',
                            color: 'white'
                          }}
                        />
                      </Box>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          mb: 1.5,
                          pl: 3.5,
                          lineHeight: 1.6,
                          fontStyle: 'italic'
                        }}
                      >
                        "{(selectedPost.content || selectedPost.description || selectedPost.title || '')?.substring(0, 120)}
                        {(selectedPost.content || selectedPost.description || selectedPost.title || '').length > 120 ? '...' : ''}"
                      </Typography>

                      <Box sx={{ display: 'flex', gap: 1, pl: 3.5, alignItems: 'center' }}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="success"
                          onClick={() => {
                            setOpenPostModal(true);
                            if (campaignType === 'reel' || campaignType === 'boost-reel') {
                              fetchUserReels();
                            } else {
                              fetchUserPosts();
                            }
                          }}
                          sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: 1.5,
                            px: 2
                          }}
                        >
                          Change {(campaignType === 'reel' || campaignType === 'boost-reel') ? 'Reel' : 'Post'}
                        </Button>
                        <Typography variant="caption" color="text.secondary">
                          • {selectedPost.likeCount || 0} likes • {selectedPost.commentCount || 0} comments
                        </Typography>
                      </Box>

                      {isBoostCampaign() && (
                        <Box sx={{ mt: 1.5, pl: 3.5 }}>
                          <Typography variant="caption" color="warning.main" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Box component="span" sx={{ fontSize: '1rem' }}>⚠️</Box>
                            This {(campaignType === 'boost-reel') ? 'reel' : 'post'} will be boosted as-is. No modifications are allowed.
                          </Typography>
                        </Box>
                      )}
                    </Paper>
                  )}

                  {/* Reel-specific: Title field */}
                  {(campaignType === 'reel' || campaignType === 'boost-reel') && (
                    <TextField
                      fullWidth
                      label="Title *"
                      value={reelTitle}
                      onChange={(e) => {
                        if (e.target.value.length <= 150) setReelTitle(e.target.value);
                      }}
                      margin="normal"
                      variant="outlined"
                      helperText={`Give your reel a catchy title. ${reelTitle.length}/150 characters`}
                      inputProps={{ maxLength: 150 }}
                      error={reelTitle.length > 150}
                      required
                      disabled={areFieldsDisabled}
                      InputProps={{
                        readOnly: areFieldsDisabled,
                      }}
                    />
                  )}

                  {/* Description field - hide for banner, hashtag, app-store, and merchant-marketplace campaigns */}
                  {campaignType !== 'banner' && campaignType !== 'hashtag' && campaignType !== 'app-store' &&
                    campaignType !== 'token-marketplace' && campaignType !== 'merchant-marketplace' && (
                      <TextField
                        fullWidth
                        label={campaignType === 'token-marketplace' ? 'Description (Optional)' : 'Campaign Description'}
                        multiline
                        rows={3}
                        value={description}
                        onChange={(e) => {
                          if (e.target.value.length <= 255) setDescription(e.target.value);
                        }}
                        margin="normal"
                        variant="outlined"
                        helperText={`${(campaignType === 'reel' || campaignType === 'boost-reel') ? 'Tell viewers what your reel is about.' : 'Briefly describe the purpose or content of your ad campaign.'} ${description.length}/255 characters`}
                        inputProps={{ maxLength: 255 }}
                        error={description.length > 255}
                        disabled={areFieldsDisabled}
                        InputProps={{
                          readOnly: areFieldsDisabled,
                        }}
                      />
                    )}

                  {/* Hide Media Type toggle for reels, boost campaigns, banner, hashtag, and new marketplace types */}
                  {campaignType !== 'reel' && campaignType !== 'boost-reel' && campaignType !== 'banner' &&
                    campaignType !== 'hashtag' && campaignType !== 'app-store' && campaignType !== 'token-marketplace' &&
                    campaignType !== 'merchant-marketplace' && !isBoostCampaign() && (
                      <Box mt={3}>
                        <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
                          Select Media Type
                        </Typography>
                        <ToggleButtonGroup
                          value={mediaType}
                          exclusive
                          onChange={(e, value) => {
                            if (value) {
                              setMediaType(value);
                              // Only clear files if switching in sponsored mode
                              if (campaignType === 'sponsored') {
                                setMediaFiles([]);
                              }
                            }
                          }}
                          color="primary"
                          sx={{ '& .MuiToggleButton-root': { textTransform: 'none' } }}
                        >
                          <ToggleButton value="single">Single Image / Video</ToggleButton>
                          <ToggleButton value="carousel">Carousel (2-6 Images / Videos)</ToggleButton>
                        </ToggleButtonGroup>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                          {mediaType === 'single' ? 'Upload exactly 1 image or video.' : 'Upload 2 to 6 images or videos.'}
                          {campaignType !== 'sponsored' && selectedPost && ' You can add more media to the post.'}
                        </Typography>
                      </Box>
                    )}

                  {/* Media Upload Section - hide for hashtag, app-store, token-marketplace, and merchant-marketplace campaigns */}
                  {campaignType !== 'hashtag' && campaignType !== 'app-store' &&
                    campaignType !== 'token-marketplace' && campaignType !== 'merchant-marketplace' && (
                      <Box mt={3}>
                        <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
                          {(campaignType === 'reel' || campaignType === 'boost-reel') ? 'Video File *' :
                            campaignType === 'banner' ? 'Banner Image * (5:1 aspect ratio)' : 'Media Files'}
                        </Typography>
                        <Grid container spacing={2}>
                          {mediaFiles.map((media, index) => (
                            <Grid item key={index}>
                              <Box
                                position="relative"
                                sx={{
                                  width: campaignType === 'banner' ? 250 : 120,
                                  height: campaignType === 'banner' ? 50 : 90,
                                  borderRadius: 1,
                                  overflow: 'hidden',
                                  border: media.isFromPost ? '2px solid' : '1px solid',
                                  borderColor: media.isFromPost ? 'primary.main' : '#e0e0e0',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                {media.isFromPost && (
                                  <Chip
                                    label={(campaignType === 'reel' || campaignType === 'boost-reel') ? 'From Reel' :
                                      (campaignType === 'boost-post' || campaignType === 'boost-tagged-post') ? 'From Post' : 'From Post'}
                                    size="small"
                                    color="primary"
                                    sx={{
                                      position: 'absolute',
                                      top: 4,
                                      left: 4,
                                      zIndex: 1,
                                      fontSize: '0.65rem',
                                      height: '18px'
                                    }}
                                  />
                                )}
                                {!areFieldsDisabled && (
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => removeMedia(index)}
                                    sx={{
                                      position: 'absolute',
                                      top: 4,
                                      right: 4,
                                      zIndex: 1,
                                      backgroundColor: 'rgba(255,255,255,0.7)',
                                      '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                                    }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {media.type.startsWith('video') ? (
                                  <video src={media.url} controls style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                  <img src={media.url} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                )}
                              </Box>
                            </Grid>
                          ))}
                          {!areFieldsDisabled && (((campaignType === 'reel' || campaignType === 'boost-reel') && mediaFiles.length < 1) ||
                            (mediaType === 'single' && mediaFiles.length < 1 && campaignType !== 'reel' && campaignType !== 'boost-reel') ||
                            (mediaType === 'carousel' && mediaFiles.length < 6)) && (
                              <Grid item>
                                <Button
                                  variant="outlined"
                                  onClick={() => fileInputRef.current.click()}
                                  sx={{
                                    width: campaignType === 'banner' ? 250 : 120,
                                    height: campaignType === 'banner' ? 70 : 90,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '2px dashed',
                                    borderColor: 'text.disabled',
                                    color: 'text.secondary',
                                    '&:hover': {
                                      borderColor: 'primary.main',
                                      color: 'primary.main',
                                      backgroundColor: 'action.hover',
                                    },
                                  }}
                                >
                                  {(campaignType === 'reel' || campaignType === 'boost-reel') ? (
                                    <VideoLibraryIcon sx={{ fontSize: 40 }} />
                                  ) : (
                                    <AddPhotoAlternateIcon sx={{ fontSize: 40 }} />
                                  )}
                                  <Typography variant="caption" mt={0.5}>
                                    {(campaignType === 'reel' || campaignType === 'boost-reel') ? 'Upload Video' :
                                      campaignType === 'banner' ? 'Upload Banner' :
                                        (campaignType !== 'sponsored' && mediaFiles.length > 0 ? 'Add More' : 'Upload Media')}
                                  </Typography>
                                  <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept={(campaignType === 'reel' || campaignType === 'boost-reel') ? VIDEO_TYPES.join(',') :
                                      campaignType === 'banner' ? IMAGE_TYPES.join(',') :
                                        (mediaType === 'single' ?
                                          `${IMAGE_TYPES.join(',')},${VIDEO_TYPES.join(',')}` :
                                          IMAGE_TYPES.join(','))}
                                    multiple={(campaignType !== 'reel' && campaignType !== 'boost-reel' && campaignType !== 'banner' && mediaType === 'carousel')}
                                    hidden
                                    onChange={handleMediaUpload}
                                  />
                                </Button>
                              </Grid>
                            )}
                        </Grid>
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                          {(campaignType === 'reel' || campaignType === 'boost-reel') ? (
                            <>MP4, MOV up to 50MB</>
                          ) : campaignType === 'banner' ? (
                            <>Accepted: Images only (JPG, PNG, GIF) up to 5MB. Images will be cropped to 5:1 aspect ratio.</>
                          ) : mediaType === 'single' ? (
                            <>Accepted: Images (JPG, PNG, GIF) up to 5MB or Videos (MP4, MOV, WMV, AVI) up to 15MB</>
                          ) : (
                            <>Accepted: Images (JPG, PNG, GIF) up to 5MB or Videos (MP4, MOV, WMV, AVI) up to 15MB</>
                          )}
                          {campaignType !== 'sponsored' && campaignType !== 'banner' && campaignType !== 'hashtag' && !isBoostCampaign() && selectedPost && (
                            <Box component="span" sx={{ display: 'block', color: 'primary.main', mt: 0.5 }}>
                              💡 Media from your {(campaignType === 'reel' || campaignType === 'boost-reel') ? 'reel' : 'post'} is loaded. You can {mediaType === 'carousel' ? 'add more' : 'replace it'}.
                            </Box>
                          )}
                          {areFieldsDisabled && (
                            <Box component="span" sx={{ display: 'block', color: 'warning.main', mt: 0.5 }}>
                              ⚠️ Media cannot be modified for boost campaigns.
                            </Box>
                          )}
                        </Typography>
                      </Box>
                    )}

                  {/* Reel-specific: Cover Image upload */}
                  {(campaignType === 'reel' || campaignType === 'boost-reel') && !areFieldsDisabled && (
                    <Box mt={3}>
                      <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
                        Cover Image (Optional)
                      </Typography>
                      {coverImage ? (
                        <Box
                          position="relative"
                          sx={{
                            width: 200,
                            height: 150,
                            borderRadius: 1,
                            overflow: 'hidden',
                            border: '1px solid #e0e0e0',
                            display: 'inline-block',
                          }}
                        >
                          {coverImage.isFromReel && (
                            <Chip
                              label="From Reel"
                              size="small"
                              color="primary"
                              sx={{
                                position: 'absolute',
                                top: 4,
                                left: 4,
                                zIndex: 1,
                                fontSize: '0.65rem',
                                height: '18px'
                              }}
                            />
                          )}
                          <IconButton
                            size="small"
                            color="error"
                            onClick={removeCoverImage}
                            sx={{
                              position: 'absolute',
                              top: 4,
                              right: 4,
                              zIndex: 1,
                              backgroundColor: 'rgba(255,255,255,0.7)',
                              '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                          <img
                            src={coverImage.url}
                            alt="cover"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        </Box>
                      ) : (
                        <Button
                          variant="outlined"
                          startIcon={<AddPhotoAlternateIcon />}
                          onClick={() => coverImageInputRef.current.click()}
                          sx={{ textTransform: 'none' }}
                        >
                          Add cover
                        </Button>
                      )}
                      <input
                        ref={coverImageInputRef}
                        type="file"
                        accept={IMAGE_TYPES.join(',')}
                        hidden
                        onChange={handleCoverImageUpload}
                      />
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                        Upload a custom cover image for your reel (JPG, PNG, GIF up to 5MB)
                      </Typography>
                    </Box>
                  )}

                  {/* Reel-specific: Hashtags field */}
                  {(campaignType === 'reel' || campaignType === 'boost-reel') && (
                    <TextField
                      fullWidth
                      label="Hashtags"
                      value={hashtags}
                      onChange={(e) => setHashtags(e.target.value)}
                      margin="normal"
                      variant="outlined"
                      placeholder="#startup #growth #business"
                      helperText="Add hashtags to help people discover your reel (e.g., #startup #growth #business)"
                      disabled={areFieldsDisabled}
                      InputProps={{
                        readOnly: areFieldsDisabled,
                      }}
                    />
                  )}

                  {/* Hide CTA and other fields for boost campaigns, hashtag, and new marketplace campaigns */}
                  {!isBoostCampaign() && campaignType !== 'hashtag' && campaignType !== 'app-store' &&
                    campaignType !== 'token-marketplace' && campaignType !== 'merchant-marketplace' && (
                      <>
                        <Divider sx={{ my: 3 }} />

                        <FormControl fullWidth margin="normal" variant="outlined">
                          <InputLabel>Call to Action (CTA)</InputLabel>
                          <Select value={cta} label="Call to Action (CTA)" onChange={(e) => setCta(e.target.value)}>
                            <MenuItem value=""><em>None</em></MenuItem>
                            <MenuItem value="Sign Up">Sign Up</MenuItem>
                            <MenuItem value="Learn More">Learn More</MenuItem>
                            <MenuItem value="Shop Now">Shop Now</MenuItem>
                            <MenuItem value="Contact Us">Contact Us</MenuItem>
                            <MenuItem value="Download">Download</MenuItem>
                          </Select>
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                            Choose a button text that encourages interaction.
                          </Typography>
                        </FormControl>

                        <TextField
                          fullWidth
                          label="Call to action URL"
                          type="url"
                          value={callToActionUrl}
                          onChange={(e) => setCallToActionUrl(e.target.value)}
                          margin="normal"
                          variant="outlined"
                          helperText="The full URL where users will be directed (e.g., https://example.com/product)"
                          placeholder="https://www.paybito.com/signup"
                        />

                        <TextField
                          fullWidth
                          label="Ad Headline"
                          value={headline}
                          onChange={(e) => {
                            if (e.target.value.length <= 100) setHeadline(e.target.value);
                          }}
                          margin="normal"
                          variant="outlined"
                          helperText={`A short, catchy headline for your ad. ${headline.length}/100 characters`}
                          inputProps={{ maxLength: 100 }}
                          error={headline.length > 100}
                          placeholder="This is the headline"
                        />

                        {/* Hide Website URL for reels or show conditionally */}
                        {campaignType !== 'reel' && campaignType !== 'boost-reel' && (
                          <TextField
                            fullWidth
                            label="Website URL"
                            type="url"
                            value={websiteUrl}
                            onChange={(e) => setWebsiteUrl(e.target.value)}
                            margin="normal"
                            variant="outlined"
                            helperText="The full URL where users will be directed (e.g., https://example.com/product)"
                          />
                        )}
                      </>
                    )}

                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      mt: 4,
                      py: 1.5,
                      fontSize: '1rem',
                      textTransform: 'uppercase',
                      position: 'relative'
                    }}
                    onClick={submitCampaign}
                    disabled={
                      isSubmitting ||
                      !campaignName ||
                      (campaignType === 'hashtag' ? !selectedHashtag :
                        campaignType === 'app-store' ? (!selectedApp || !cta || !callToActionUrl) :
                          campaignType === 'token-marketplace' ? (!selectedToken || !cta || !callToActionUrl) :
                            campaignType === 'merchant-marketplace' ? (!selectedMerchant || !cta || !callToActionUrl) :
                              (campaignType !== 'banner' && !description) ||
                              (campaignType !== 'hashtag' && campaignType !== 'app-store' &&
                                campaignType !== 'token-marketplace' && campaignType !== 'merchant-marketplace' &&
                                mediaFiles.length === 0)) ||
                      ((campaignType === 'reel' || campaignType === 'boost-reel') && !reelTitle && !isBoostCampaign())
                    }
                  >
                    {isSubmitting ? (
                      <>
                        <CircularProgress
                          size={24}
                          color="inherit"
                          sx={{
                            position: 'absolute',
                            left: '50%',
                            marginLeft: '-12px',
                          }}
                        />
                        <span style={{ opacity: 0 }}>CREATE CAMPAIGN</span>
                      </>
                    ) : (
                      'CREATE CAMPAIGN'
                    )}
                  </Button>
                </Paper>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 5 }}>
              {/* Right Side - Live Preview */}
              <Box sx={{ flex: 5 }}>
                <Paper elevation={4} sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }}>
                  <Typography variant="h6" gutterBottom color="text.primary" fontWeight="medium">
                    Live Ad Preview
                  </Typography>
                  <Divider sx={{ mb: 2 }} />

                  {/* Special preview for hashtag campaigns */}
                  {campaignType === 'hashtag' ? (
                    <Box sx={{ p: 3, border: '1px solid #333', borderRadius: 1, bgcolor: 'background.paper', textAlign: 'center' }}>
                      <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                        <Box
                          sx={{
                            width: 48,
                            height: 48,
                            borderRadius: '50%',
                            bgcolor: 'primary.light',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mr: 1.5,
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '1.2rem',
                          }}
                        >
                          #
                        </Box>
                        <Box textAlign="left">
                          <Typography variant="subtitle1" fontWeight="bold">
                            {brokerDetails?.firstName} {brokerDetails?.lastName}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Sponsored Hashtag
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          py: 4,
                          px: 2,
                          bgcolor: 'action.hover',
                          borderRadius: 2,
                          mb: 2
                        }}
                      >
                        <Typography variant="h4" fontWeight="bold" color="primary.main" mb={1}>
                          {selectedHashtag ?
                            `#${userHashtags.find(h => h.hashtagId === selectedHashtag)?.hashtagName || ''}` :
                            '#YourHashtag'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Promoted hashtag campaign
                        </Typography>
                      </Box>

                      <Typography variant="caption" color="text.secondary">
                        Users will see this hashtag promoted across the platform
                      </Typography>
                    </Box>
                  ) : campaignType === 'app-store' ? (
                    <Box sx={{ p: 3, border: '1px solid #333', borderRadius: 1, bgcolor: 'background.paper' }}>
                      <Box display="flex" alignItems="center" mb={2}>
                        <Box
                          sx={{
                            width: 48,
                            height: 48,
                            borderRadius: 2,
                            bgcolor: 'primary.light',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mr: 1.5,
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '1.5rem',
                          }}
                        >
                          📱
                        </Box>
                        <Box>
                          <Typography variant="subtitle1" fontWeight="bold">
                            {selectedApp ? userApps.find(a => a.appId === selectedApp)?.appName || 'App Name' : 'Your App'}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Featured on PayBito App Store
                          </Typography>
                        </Box>
                      </Box>

                      <Typography variant="body2" color="text.secondary" mb={2}>
                        Get this amazing app now and enhance your experience!
                      </Typography>

                      {cta && (
                        <Button
                          variant="contained"
                          size="small"
                          fullWidth
                          disabled
                          sx={{ textTransform: 'uppercase', py: 1 }}
                        >
                          {cta}
                        </Button>
                      )}
                    </Box>
                  ) :
                    campaignType === 'token-marketplace' ? (
                      <Box sx={{ p: 3, border: '1px solid #333', borderRadius: 1, bgcolor: 'background.paper' }}>
                        <Box display="flex" alignItems="center" mb={2}>
                          <Box
                            sx={{
                              width: 48,
                              height: 48,
                              borderRadius: '50%',
                              bgcolor: 'warning.light',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              mr: 1.5,
                              color: 'white',
                              fontWeight: 'bold',
                              fontSize: '1.2rem',
                            }}
                          >
                            {/* 🔥 USE ACTUAL API FIELD NAMES */}
                            {selectedToken ?
                              (userTokens.find(t => t.tokenId === selectedToken)?.tokenSymbol?.substring(0, 2) || '₿') : '₿'}
                          </Box>
                          <Box>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {/* 🔥 USE ACTUAL API FIELD NAMES */}
                              {selectedToken ?
                                (userTokens.find(t => t.tokenId === selectedToken)?.tokenName || 'Token Name') : 'Your Token'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {/* 🔥 USE ACTUAL API FIELD NAMES */}
                              {selectedToken ?
                                (userTokens.find(t => t.tokenId === selectedToken)?.tokenSymbol || 'SYMBOL') : 'Featured Token'}
                            </Typography>
                          </Box>
                        </Box>

                        {headline && (
                          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                            {headline}
                          </Typography>
                        )}

                        {description && (
                          <Typography variant="body2" color="text.secondary" mb={2}>
                            {description}
                          </Typography>
                        )}

                        {cta && (
                          <Button
                            variant="contained"
                            size="small"
                            fullWidth
                            disabled
                            sx={{ textTransform: 'uppercase', py: 1 }}
                          >
                            {cta}
                          </Button>
                        )}
                      </Box>
                    ) :
                      campaignType === 'merchant-marketplace' ? (
                        <Box sx={{ p: 3, border: '1px solid #333', borderRadius: 1, bgcolor: 'background.paper' }}>
                          <Box display="flex" alignItems="center" mb={2}>
                            <Box
                              sx={{
                                width: 48,
                                height: 48,
                                borderRadius: 1,
                                bgcolor: 'success.light',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 1.5,
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '1.5rem',
                              }}
                            >
                              🏪
                            </Box>
                            <Box>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {selectedMerchant ?
                                  (userMerchants.find(m => m.merchantId === selectedMerchant)?.organizationName ||
                                    userMerchants.find(m => m.merchantId === selectedMerchant)?.fullName ||
                                    'Store Name') : 'Your Store'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Featured on Crypto Commerce
                              </Typography>
                            </Box>
                          </Box>

                          <Typography variant="body2" color="text.secondary" mb={2}>
                            Discover amazing products and services from this featured merchant!
                          </Typography>

                          {cta && (
                            <Button
                              variant="contained"
                              size="small"
                              fullWidth
                              disabled
                              sx={{ textTransform: 'uppercase', py: 1 }}
                            >
                              {cta}
                            </Button>
                          )}
                        </Box>
                      ) : (
                        <Box sx={{ p: 2, border: '1px solid #333', borderRadius: 1, bgcolor: 'background.paper' }}>
                          <Box display="flex" alignItems="center" mb={1}>
                            <Box
                              sx={{
                                width: 36,
                                height: 36,
                                borderRadius: '50%',
                                bgcolor: 'primary.light',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 1,
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '0.8rem',
                              }}
                            >
                              AD
                            </Box>
                            <Box>
                              <Typography variant="subtitle2" fontWeight="bold">
                                {brokerDetails?.firstName} {brokerDetails?.lastName}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Sponsored
                              </Typography>
                            </Box>
                          </Box>

                          {/* Show reel title if it's a reel campaign */}
                          {(campaignType === 'reel' || campaignType === 'boost-reel') && reelTitle && (
                            <Typography variant="subtitle1" fontWeight="bold" mb={0.5}>
                              {reelTitle}
                            </Typography>
                          )}

                          {campaignType !== 'banner' && (
                            <Typography variant="body2" color="text.primary" mb={1}>
                              {description || ((campaignType === 'reel' || campaignType === 'boost-reel') ? 'Tell viewers what your reel is about...' : 'This is where your campaign description will appear in the ad. Keep it concise and engaging!')}
                            </Typography>
                          )}

                          {/* Show hashtags if it's a reel */}
                          {(campaignType === 'reel' || campaignType === 'boost-reel') && hashtags && (
                            <Typography variant="body2" color="primary.main" mb={1}>
                              {hashtags}
                            </Typography>
                          )}

                          {mediaFiles.length > 0 && (
                            <Box sx={{ mb: 1.5 }}>
                              {mediaType === 'single' || campaignType === 'reel' || campaignType === 'boost-reel' || campaignType === 'banner' ? (
                                <Box
                                  sx={{
                                    width: '100%',
                                    height: campaignType === 'banner' ? 100 : 200,
                                    borderRadius: 1,
                                    backgroundColor: '#23272f',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    overflow: 'hidden',
                                    position: 'relative',
                                  }}
                                >
                                  {mediaFiles[0].type.startsWith('video') ? (
                                    <video
                                      src={mediaFiles[0].url}
                                      controls={false}
                                      autoPlay
                                      muted
                                      loop
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: campaignType === 'banner' ? 'contain' : 'cover',
                                        background: '#23272f'
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={mediaFiles[0].url}
                                      alt="preview"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: campaignType === 'banner' ? 'contain' : 'cover',
                                        background: '#23272f'
                                      }}
                                    />
                                  )}
                                  {/* Show cover image overlay for reels if available */}
                                  {(campaignType === 'reel' || campaignType === 'boost-reel') && coverImage && (
                                    <Box
                                      sx={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        width: 60,
                                        height: 60,
                                        borderRadius: 1,
                                        overflow: 'hidden',
                                        border: '2px solid white',
                                        boxShadow: 2,
                                      }}
                                    >
                                      <img
                                        src={coverImage.url}
                                        alt="cover preview"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                      />
                                    </Box>
                                  )}
                                </Box>
                              ) : (
                                <Box sx={{
                                  width: '100%',
                                  height: 300,
                                  position: 'relative',
                                  overflow: 'hidden',
                                  borderRadius: 1,
                                  backgroundColor: '#23272f',
                                  mb: 1.5,
                                  '& .slick-prev:before, & .slick-next:before': {
                                    color: 'primary.main',
                                    fontSize: '24px'
                                  },
                                  '& .slick-prev': {
                                    left: '25px',
                                    zIndex: 1
                                  },
                                  '& .slick-next': {
                                    right: '25px',
                                    zIndex: 1
                                  }
                                }}>
                                  <Slider {...settings}>
                                    {mediaFiles.map((media, index) => (
                                      <Box
                                        key={index}
                                        sx={{
                                          height: 300,
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          backgroundColor: '#23272f',
                                          overflow: 'hidden'
                                        }}
                                      >
                                        {media.type.startsWith('video') ? (
                                          <video
                                            src={media.url}
                                            controls={false}
                                            autoPlay
                                            muted
                                            loop
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              objectFit: 'contain'
                                            }}
                                          />
                                        ) : (
                                          <img
                                            src={media.url}
                                            alt={`preview-${index}`}
                                            style={{
                                              width: '100%',
                                              height: 'auto',
                                              maxHeight: '100%',
                                              objectFit: 'contain'
                                            }}
                                          />
                                        )}
                                      </Box>
                                    ))}
                                  </Slider>
                                </Box>
                              )}
                            </Box>
                          )}

                          {mediaFiles.length === 0 && (
                            <Box
                              sx={{
                                width: '100%',
                                height: campaignType === 'banner' ? 100 : 200,
                                borderRadius: 1,
                                backgroundColor: '#23272f',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '1px dashed #444',
                                mb: 1.5,
                                color: 'text.disabled'
                              }}
                            >
                              {(campaignType === 'reel' || campaignType === 'boost-reel') ? (
                                <VideoLibraryIcon sx={{ fontSize: 48, mb: 1, color: '#444' }} />
                              ) : (
                                <AddPhotoAlternateIcon sx={{ fontSize: 48, mb: 1, color: '#444' }} />
                              )}
                              <Typography variant="body2">
                                {(campaignType === 'reel' || campaignType === 'boost-reel') ? 'Video Preview' :
                                  campaignType === 'banner' ? 'Banner Image Preview' :
                                    (mediaType === 'single' ? 'Media Preview' : 'Carousel Preview')}
                              </Typography>
                            </Box>
                          )}

                          {!isBoostCampaign() && (
                            <>
                              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }}>
                                {headline || 'Your Ad Headline Here'}
                              </Typography>

                              {campaignType !== 'reel' && campaignType !== 'boost-reel' && (
                                <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                                  {websiteUrl || 'yourwebsite.com'}
                                </Typography>
                              )}

                              {cta ? (
                                <Button
                                  size="small"
                                  variant="contained"
                                  sx={{ mt: 1, textTransform: 'uppercase', py: 0.7, px: 2 }}
                                  disabled
                                >
                                  {cta}
                                </Button>
                              ) : (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    mt: 1,
                                    textTransform: 'uppercase',
                                    py: 0.7,
                                    px: 2,
                                    color: 'text.disabled',
                                    borderColor: 'text.disabled'
                                  }}
                                  disabled
                                >
                                  CTA Not Selected
                                </Button>
                              )}
                            </>
                          )}
                        </Box>
                      )}
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* Banner Image Cropper Modal */}
      <BannerImageCropper
        open={cropperOpen}
        onClose={() => setCropperOpen(false)}
        imageSrc={imageToCrop}
        onCropComplete={handleCroppedImage}
      />
    </Container>
  );
};

export default CreateCampaignPage;